import { render, staticRenderFns } from "./ExaminationDetailAdd.vue?vue&type=template&id=6c91d7f7&scoped=true"
import script from "./ExaminationDetailAdd.vue?vue&type=script&lang=js"
export * from "./ExaminationDetailAdd.vue?vue&type=script&lang=js"
import style0 from "./ExaminationDetailAdd.vue?vue&type=style&index=0&id=6c91d7f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91d7f7",
  null
  
)

export default component.exports